import { useWindowDimensions } from 'react-native';

export const useAppDimensions = () => {
    const { height, width } = useWindowDimensions();
    const vh = (number: number) => height * (number / 100);
    const vw = (number: number) => width * (number / 100);


    return { vh, vw };
};